export default "__VITE_ASSET__336b72a1__"